/**
 * clipboard helper functions.
 */

/**
 * pass string for content to be copied to clipboard
 * @param {string} value
 */
export const copyValueToClipboard = (value: string): void => {
    // create a textarea element hidden off page
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    // insert the value
    selBox.value = value
    document.body.appendChild(selBox)
    // find the textarea and select its contents
    selBox.focus()
    selBox.select()
    selBox.setSelectionRange(0, selBox.value.length) // iOS devices
    // run the copy command
    document.execCommand('copy')
    // clean up the textarea
    document.body.removeChild(selBox)
}
